import React from 'react';
import CodeBlock from '../components/CodeBlock.js';
import { renderingRule, renderReact } from '../utils/markdown.plugin.utils.js';
import prop from '../node_modules/ramda/es/prop.js';

/**
 * REGEXP for TrimWhitespaceFromSource rendering rule. Splits input
 * into three groups where the second is the content of the code block
 * and the first and third are the HTML elements before and after the
 * content respectively, eg.
 *
 * 1. <pre class="hljs"><code>
 * 2. *Content of code block entered by author*
 * 3. </code></pre>
 *
 * @type {RegExp}
 */
const CODE_HTML_EXP = new RegExp('(.*<code>)([^]*)(</code>.*)', 'm');

/**
 * In order to make the <pre> element keyboard accessible, ex the ability
 * to scroll left and right, we need to give it a tabindex.
 *
 * @example
 * <pre class="hljs"><code>
 *
 * will be returned as:
 *
 * <pre tabindex="0" class="hljs"><code>
 *
 * @param {String} part String containing "<pre ..."
 */
const addTabIndexToPre = part => {
  const partStart = '<pre';
  if (!part.startsWith(partStart)) return part;
  const [, partEnd] = part.split(partStart);
  return "".concat(partStart, " tabindex=\"0\" ").concat(partEnd);
};

/**
 * Rendering rule for 'fence' (aka code blocks) that trims whitespace from the
 * end of the content that will be inserted between <pre><code> and </code></pre>.
 *
 * ```
 *    some code be here
 *
 * ```
 *
 * is rendered as:
 *
 * <pre><code>   some code be here</code></pre>
 */
const TrimWhitespaceFromSource = renderingRule('fence', _ref => {
  let {
    origRender
  } = _ref;
  const origRendered = origRender();
  const codeHtmlParts = CODE_HTML_EXP.exec(origRendered);
  if (codeHtmlParts && codeHtmlParts.length === 4) {
    codeHtmlParts[1] = addTabIndexToPre(codeHtmlParts[1]);
    return [codeHtmlParts[1], codeHtmlParts[2].trimEnd(), codeHtmlParts[3]].join('');
  }
  return origRendered;
});

/**
 * Rendering rule that injects a React component for fence (source code) blocks
 * that has custom HTML/CSS and a button to copy text to the clipboard.
 */
const CodeBlockComponent = renderingRule('fence', renderReact(_ref2 => {
  let {
    origContents,
    elementId,
    content
  } = _ref2;
  return /*#__PURE__*/React.createElement(CodeBlock, {
    elementId: elementId,
    content: prop('content', content)
  }, origContents());
}));
var RenderCodeBlock = [TrimWhitespaceFromSource, CodeBlockComponent];

export { CodeBlockComponent, TrimWhitespaceFromSource, RenderCodeBlock as default };
